import React from 'react';
import { withRouter } from 'react-router-dom';
import withForm from 'modules/common/hoc/withForm';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../container/records/action';

const ViewImage = ({ isLoading, handleGetPhoto, item }) => {

  return !_.isEmpty(_.get(item, 'front_page')) || !_.isEmpty(_.get(item, 'back_page')) ? (
    <>
      {_.get(item, 'front_page') ? (
        <button
          disabled={isLoading}
          type="submit"
          className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2 btn-sm"
          onClick={handleGetPhoto(item, 'front')}
        >
          {isLoading && <i className="fa fa-spin fa-spinner" />}

          {!isLoading && (
            <>
              View Front&nbsp;
              <i className="fa fa-search" />
            </>
          )}
        </button>
      ) : (
        <button
          disabled={isLoading}
          type="submit"
          className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2 btn-sm"
          onClick={handleGetPhoto(item, 'back')}
        >
          {isLoading && <i className="fa fa-spin fa-spinner" />}

          {!isLoading && (
            <>
              View Back&nbsp;
              <i className="fa fa-search" />
            </>
          )}
        </button>
      )}
    </>
  ) : (
    <small className="text-danger">no image found!</small>
  );
};

ViewImage.defaultProps = {
  isLoading: undefined,
};

ViewImage.propTypes = {
  isLoading: PropTypes.bool,
  handleGetPhoto: PropTypes.instanceOf(Function).isRequired,
  // getImage: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewImage);
